import { Instagram, Mail, Phone } from "lucide-react";
import { BRAND } from "../../lib/brand";
import { Reveal } from "./Reveal";

export default function Footer() {
  return (
    <footer
      className="relative bg-cream border-t border-olive/15 pt-16 md:pt-24 pb-10"
      data-testid="site-footer"
    >
      <div className="mx-auto max-w-[1500px] px-6 md:px-10">
        <Reveal>
          <div className="font-serif text-olive text-[14vw] md:text-[10vw] leading-[0.9] tracking-tightest">
            Corps <span className="italic text-gold">&amp;</span> Sens
          </div>
        </Reveal>

        <div className="mt-16 grid md:grid-cols-2 gap-10">
          <div>
            <p className="text-[11px] uppercase tracking-[0.3em] text-olive/60">
              Contact
            </p>
            <div className="mt-4 flex flex-col gap-3 text-olive/85 font-light">
              <a
                href={BRAND.phoneHref}
                className="link-underline inline-flex items-center gap-2 w-fit"
                data-testid="footer-phone"
              >
                <Phone className="h-4 w-4 text-gold" strokeWidth={1.4} />
                {BRAND.phoneDisplay}
              </a>
              <a
                href={`mailto:${BRAND.email}`}
                className="link-underline inline-flex items-center gap-2 w-fit"
                data-testid="footer-email"
              >
                <Mail className="h-4 w-4 text-gold" strokeWidth={1.4} />
                {BRAND.email}
              </a>
            </div>
          </div>

          <div className="md:text-right">
            <p className="text-[11px] uppercase tracking-[0.3em] text-olive/60">
              Suivre
            </p>
            <div className="mt-4 flex items-center gap-4 md:justify-end">
              <a
                href={BRAND.instagram}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-instagram"
                className="h-11 w-11 rounded-full border border-olive/25 grid place-items-center text-olive hover:bg-gold hover:text-cream hover:border-gold transition-all duration-500"
              >
                <Instagram className="h-4 w-4" strokeWidth={1.4} />
              </a>
            </div>
          </div>
        </div>

        <div className="hairline mt-20 mb-6" />
        <div className="flex justify-end text-olive/55 text-[11px] uppercase tracking-[0.24em]">
          <span className="italic normal-case tracking-normal font-serif text-olive/60">
            Le geste juste, pour un corps entendu.
          </span>
        </div>
      </div>
    </footer>
  );
}
